"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _popper = _interopRequireDefault(require("popper.js"));

var _reactPortal = require("react-portal");

var _classnames = _interopRequireDefault(require("classnames"));

var _PopperContainerContext = _interopRequireWildcard(require("./PopperContainerContext"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source))).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class PopperContainer
 * @desc A container that uses the popper.js positioning engine and react-portal to render
 *       and position an element that's attached to but above another element
 *
 * @param {string} [data-id="popper-container"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {function} [getReference]
 *     Provide a function that returns the ref for the element that this will be attached to.
 * @param {object} [config]
 *     The config object that popper.js uses. A good default is used when this is not supplied.
 * @param {string} [pointerClassName]
 *     CSS classes to set on the arrow element.
 * @param {string} [role]
 *     The role attribute for the container.
 * @param {function} [onClick]
 *     Click event for the container
 * @param {string} [placement]
 *     Where we'll try to put the container. Passed to popper.js
 * @param {boolean} [matchWidth=false]
 *     Should the popper match the width of its reference? (Like a dropdown does)
  * @param {boolean} [matchMinWidth=false]
 *     Should the popper match the the min width of the reference.
 * @param {boolean} [noGPUacceleration=false]
 *     Turns off a popper.js feature that conflicts with rendering helphint inside dropdowns
 * @param {boolean} [positionFixed=false]
 *     Turns on a popper.js feature
 */

/**
 * @enum {string}
 * @desc Enum for the different position options.
 */
var positions = {
  /** Left */
  LEFT: "left",

  /** Right */
  RIGHT: "right",

  /** Top */
  TOP: "top",

  /** Bottom */
  BOTTOM: "bottom"
};

var PopperContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PopperContainer, _React$Component);

  var _super = _createSuper(PopperContainer);

  function PopperContainer() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, PopperContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_popperAPI", null);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getComputedZIndex", function (node) {
      if (node && window.getComputedStyle) {
        var parentZIndex = "auto";

        if (node.parentNode && node.parentNode !== document.body) {
          parentZIndex = _this._getComputedZIndex(node.parentNode);
        }

        if (parentZIndex === "auto") {
          return window.getComputedStyle(node).zIndex;
        }

        return parentZIndex;
      }

      return "auto";
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_matchReferenceWidth", function (data) {
      data.styles.minWidth = data.offsets.reference.width + "px";
      data.styles.maxWidth = data.offsets.reference.width + "px";
      data.styles.left = data.offsets.reference.left + "px";
      return data;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_matchReferenceMinWidth", function (data) {
      data.styles.minWidth = data.offsets.reference.width + "px";
      data.styles.left = data.offsets.reference.left + "px";
      return data;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_setZIndex", function (zIndex) {
      return function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          styles: _objectSpread(_objectSpread({}, data.styles), {}, {
            zIndex: zIndex
          })
        });
      };
    });
    return _this;
  }

  (0, _createClass2.default)(PopperContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          placement = _this$props.placement,
          isDetachable = _this$props.isDetachable;
      var flipBehavior = placement.search(/top/) >= 0 ? [positions.TOP, positions.BOTTOM, positions.TOP] : [positions.BOTTOM, positions.TOP, positions.BOTTOM];
      var reference = this.props.getReference();

      var zIndex = this._getComputedZIndex(_reactDom.default.findDOMNode(reference));

      var priorityOverflow = isDetachable ? [positions.RIGHT, positions.LEFT, positions.TOP, positions.BOTTOM] //revert to default behavior
      : [positions.RIGHT, positions.LEFT];

      if (reference && this.props.scrollTo) {
        reference.scrollIntoView();
      }

      var config = this.props.config || {
        placement: placement,
        isDetachable: isDetachable,
        computeStyle: {
          gpuAcceleration: false
        },
        modifiers: {
          //Let tooltip escape scrolling container, but not app frame
          preventOverflow: {
            boundariesElement: "scrollParent",
            padding: 40,
            priority: priorityOverflow
          },
          addZIndex: {
            enabled: zIndex !== "auto",
            order: 810,
            fn: this._setZIndex(zIndex)
          },
          flip: {
            behavior: flipBehavior
          },
          autoWidth: {
            enabled: this.props.matchWidth,
            order: 650,
            fn: this._matchReferenceWidth
          },
          autoMinWidth: {
            enabled: this.props.matchMinWidth,
            order: 650,
            fn: this._matchReferenceMinWidth
          },
          computeStyle: {
            gpuAcceleration: !this.props.noGPUAcceleration
          },
          positionFixed: this.props.positionFixed,
          arrow: {
            element: "[data-x-arrow]"
          }
        }
      };

      if (reference) {
        this.popperAPI = new _popper.default(_reactDom.default.findDOMNode(reference), _reactDom.default.findDOMNode(this.popper), config);
        window.requestAnimationFrame(this.popperAPI.update); // Run this so that popper repositions itself in case something makes the
        // children have a different height than the last children - https://jira.pingidentity.com/browse/UIP-3005

        if (global.MutationObserver) {
          this.observer = new MutationObserver(function () {
            if (_this2.popperAPI && _this2.popperAPI.scheduleUpdate) {
              _this2.popperAPI.scheduleUpdate();
            }
          });
          this.observer.observe(this.popper, {
            attributes: true,
            subtree: true,
            childList: true,
            attributeFilter: ["class", "value"]
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var classes = (0, _classnames.default)("popper-container", this.props.className);
      var _this$props2 = this.props,
          dataId = _this$props2["data-id"],
          dataParent = _this$props2["data-parent"],
          children = _this$props2.children,
          pointerClassName = _this$props2.pointerClassName,
          role = _this$props2.role,
          onClick = _this$props2.onClick,
          hasPopperParent = _this$props2.hasPopperParent;

      var rendered = /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId,
        "data-parent": dataParent,
        className: classes,
        ref: function ref(el) {
          return _this3.popper = el;
        },
        role: role,
        onClick: onClick
      }, children, pointerClassName && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("popper-container__pointer", pointerClassName),
        "data-x-arrow": ""
      }));

      return /*#__PURE__*/_react.default.createElement(_PopperContainerContext.default.Provider, {
        value: _PopperContainerContext.isNested
      }, !hasPopperParent ? /*#__PURE__*/_react.default.createElement(_reactPortal.Portal, null, rendered) : rendered);
    }
  }]);
  return PopperContainer;
}(_react.default.Component);

(0, _defineProperty3.default)(PopperContainer, "propTypes", {
  "data-id": _propTypes.default.string,
  getReference: _propTypes.default.func.isRequired,
  config: _propTypes.default.object,
  pointerClassName: _propTypes.default.string,
  role: _propTypes.default.string,
  hasPopperParent: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  placement: _propTypes.default.string,
  matchWidth: _propTypes.default.bool,
  matchMinWidth: _propTypes.default.bool,
  noGPUAcceleration: _propTypes.default.bool,
  positionFixed: _propTypes.default.bool,
  scrollTo: _propTypes.default.bool,
  isDetachable: _propTypes.default.bool
});
(0, _defineProperty3.default)(PopperContainer, "defaultProps", {
  "data-id": "popper-container",
  placement: "bottom",
  matchMinWidth: false,
  matchWidth: false,
  noGPUAcceleration: false,
  positionFixed: false,
  hasPopperParent: false,
  isDetachable: false
});
var _default = PopperContainer;
exports.default = _default;
module.exports = exports["default"];